import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { MdCreditScore } from "react-icons/md";
import { Link } from "react-router-dom";
import useTranslation from '../../lib/i18n/useTranslation';
export default function SuccessPage() {
  const { t } = useTranslation();
  return (
    <Flex
      alignItems={"stretch"}
      justifyContent={"center"}
      flex="1"
      padding={3}
      >
      <Flex
        flexDirection={"column"}
        border={"1px solid"}
        borderColor={"divider.grey"}
        backgroundColor={"white"}
        alignItems={"center"}
        justifyContent={"center"}
        flex="1"
        >
        <Icon
          as={MdCreditScore}
          color={'fill.green'}
          boxSize={'50px'}
          mb={3}
          borderRadius={"2px"}
        />
        <Text>{t('payment.thankYouSubscription')}</Text>
        <Text>{t('payment.paymentSuccessful')}</Text>
        <Link to="/home">
          <Button variant="coralOutline" mt={3}>{t('payment.goHome')}</Button>
        </Link>
      </Flex>
    </Flex>
  );
}
